// extracted by mini-css-extract-plugin
export default {"settings":"BrandGroup_settings__3jArj","colorUser":"BrandGroup_colorUser__jlVZt","footer":"BrandGroup_footer__CGyRG"};